export default __webpack_public_path__ + "static/media/sign-in.5b0d8745.png";